const { gql } = require("@apollo/client");

const GROUPS_QUERY = gql`
  query groupsQuery(
    $retailerId: String!
  ) {
    groups(
      input: {
        retailerId: $retailerId
      }
    ) {
      groups {
        id
        name  
        childGroups {
          id
          name
          stationGuids
        }
      }
    }
  }
`

export {
  GROUPS_QUERY
}